
import { of as observableOf,  Observable, firstValueFrom } from 'rxjs'
import { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { StoreThunkDispatch } from 'store/state'
import { getTags as getQuotesTags } from 'services/content/quotes/actions'
import { getTags as getStatusesTags, searchStatusIdeas } from 'services/content/statuses/actions'
import { getRandomElements } from 'shared/utils'
import { searchStockContent } from 'services/search/actions'
import { getRandomSearchQuery } from 'routes/search/state/actions'
import { catchError } from 'rxjs/operators'
import { ContentItem } from 'interfaces'
import { getQuotes } from 'admin/services/quotes/actions'

export function FetchRandomContent(props: { onFetched: (source: 'quotes' | 'statuses' | 'articles', items: ContentItem[]) => void }) {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const [quotesTags, setQuotesTags] = useState<string[]>([])
  const [statusesTags, setStatusesTags] = useState<string[]>([])
  // EXPL: keep latest onFetched in a ref so the fetch effects below stay keyed on
  // dispatch/tags only — the parent passes a non-memoized callback that would otherwise
  // re-trigger the random fetches on every render.
  const onFetchedRef = useRef(props.onFetched)
  useEffect(() => {
    onFetchedRef.current = props.onFetched
  })

  useEffect(() => {
    const fetchTags = async () => {
      const response = await Promise.all([
        firstValueFrom(dispatch(getQuotesTags(false))),
        firstValueFrom(dispatch(getStatusesTags()))
      ])

      setQuotesTags(response[0].map((t: any) => t.name))
      setStatusesTags(response[1].map((t: any) => t.name))
    }

    fetchTags()
  }, [dispatch])

  useEffect(() => {
    const sub = dispatch(searchStockContent(getRandomSearchQuery(), 'articles', 'google')).pipe(catchError((error) => {
      return observableOf({ error })
    }))
      .subscribe(response => {
        if (!response.error) {
          onFetchedRef.current('articles', response)
        }
      })

    return () => sub.unsubscribe()
  }, [dispatch])

  useEffect(() => {
    let sub: any
    if (quotesTags.length > 0) {
      sub = dispatch(getQuotes(0, '', getRandomElements(quotesTags, 1)[0]))
        .subscribe((response: any) => onFetchedRef.current('quotes', response))
    }
    return () => {
      sub?.unsubscribe()
    }
  }, [dispatch, quotesTags])

  useEffect(() => {
    let sub: any
    if (statusesTags.length > 0) {
      sub = dispatch(searchStatusIdeas('', 0, getRandomElements(statusesTags, 1)[0]))
        .subscribe((response: any) => onFetchedRef.current('statuses', response.data))
    }
    return () => {
      sub?.unsubscribe()
    }
  }, [dispatch, statusesTags])

  return null
}
export default FetchRandomContent
